import { Link } from "@inertiajs/react"
import {
  Building2,
  FileText,
  LayoutGrid,
  ShieldCheck,
  UserCog,
  Users,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { usePermissions } from "@/hooks/use-permissions"
import {
  adminPropertiesPath,
  adminRolesPath,
  adminUsersPath,
  agentPropertiesPath,
  brokerBrochuresPath,
  brokerPropertiesPath,
  dashboardPath,
} from "@/routes"
import type { NavItem } from "@/types"

import AppLogo from "./app-logo"

export function AppSidebar() {
  const { can } = usePermissions()

  // Nav follows permissions, not role names — a custom role sees exactly the
  // links its keys allow. The server enforces the same keys either way.
  const navItems: NavItem[] = [
    { title: "Dashboard", href: dashboardPath(), icon: LayoutGrid },
    ...(can("admin_portal") && can("properties_index")
      ? [{ title: "Properties", href: adminPropertiesPath(), icon: Building2 }]
      : []),
    ...(can("agent_portal") && can("properties_index")
      ? [
          {
            title: "My Properties",
            href: agentPropertiesPath(),
            icon: Building2,
          },
        ]
      : []),
    ...(can("broker_portal") && can("properties_index")
      ? [
          {
            title: can("admin_portal") ? "Broker Portal" : "Properties",
            href: brokerPropertiesPath(),
            icon: Users,
          },
        ]
      : []),
    ...(can("broker_portal") && can("brochures_index")
      ? [{ title: "Brochures", href: brokerBrochuresPath(), icon: FileText }]
      : []),
    ...(can("admin_portal") && can("users_index")
      ? [{ title: "Users", href: adminUsersPath(), icon: UserCog }]
      : []),
    ...(can("admin_portal") && can("roles_index")
      ? [{ title: "Roles", href: adminRolesPath(), icon: ShieldCheck }]
      : []),
  ]

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              size="lg"
              render={<Link href={dashboardPath()} prefetch />}
            >
              <AppLogo />
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={navItems} />
      </SidebarContent>

      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
